import Vue from "vue";
import { ActionTree, MutationTree, GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { ServerResult } from "@/core/http/server_result";
import moment from "moment";

interface UtilsState {
  loaded: boolean;
  loading: boolean;
  settings: any[];
}

const state: UtilsState = {
  loading: false,
  loaded: false,
  settings: []
};

export const ITEMS_LIST = "ITEMS_LIST";

export const actions: ActionTree<UtilsState, RootState> = {
  loadData({ commit, getters, dispatch, state }) {
    const vm = (this as any)._vm;

    return new Promise((resolve, reject) => {
      commit("START_LOADING");

      vm.$db([
        vm
          .$q(ITEMS_LIST)
          .raw("documents.list")
          .action({
            columns: {
              id: "s.id",
              type: "s.type",
              label: "s.label",
              value: "s.value",
              group_name: "s.group_name"
            },
            from: "s:settings",
            from_as: "s",
            order: [{ $asc: ["s.id"] }]
          })
      ]).then((result: ServerResult) => {
        commit("SET_ITEMS_LIST", result.getOperation(ITEMS_LIST).getContent());
        commit("LOADED_SUCCESS");

        resolve(null);
      });
    });
  },

  setValue({ commit }, { group, field, newValue }) {
    commit("SET_VALUE", { group, field, newValue });
  },

  saveSetting({ state, commit }, { group }) {
    const _group = state.settings.filter((item: any) => {
      return item.name == group.name;
    })[0];
    const vm = (this as any)._vm;
    return new Promise((resolve, reject) => {
      const queries: any[] = _group.settings.map((item: any, idx: number) => {
        return vm.$q(`SHIFT_DATA_SAVE-${idx}`).update(item.id, {
          value: "" + item.value
        });
      });
      commit("SET_FIELD_PROCESSING", group);
      vm.$db(queries).then((result: ServerResult) => {
        resolve(null);
        commit("SET_FIELD_PROCESSED", group);
      });
    });
  }
};

export const mutations: MutationTree<UtilsState> = {
  START_LOADING: state => {
    state.loaded = false;
    state.loading = true;
  },
  LOADED_SUCCESS: state => {
    state.loaded = true;
    state.loading = false;
  },
  SET_ITEMS_LIST: (state, result) => {
    state.settings = Object.values(
      result.documents.reduce((acc: any, item: any) => {
        if (!acc[item.group_name]) {
          acc[item.group_name] = {
            name: item.group_name,
            saved: true,
            processing: false,
            settings: []
          };
        }
        acc[item.group_name].settings.push(item);
        return acc;
      }, {})
    );
  },

  SET_VALUE: (state, { group, field, newValue }) => {
    const _group = state.settings.filter((item: any) => {
      return item.name == group.name;
    })[0];
    const _field = _group.settings.filter((item: any) => {
      return item == field;
    })[0];
    _group.saved = false;
    _field.value = newValue;
  },

  SET_FIELD_PROCESSING: (state, group) => {
    const _field = state.settings.filter((item: any) => {
      return item.name == group.name;
    })[0];
    _field.processing = true;
  },

  SET_FIELD_PROCESSED: (state, group) => {
    const _field = state.settings.filter((item: any) => {
      return item.name == group.name;
    })[0];
    _field.processing = false;
    _field.saved = true;
  }
};

const getters: GetterTree<UtilsState, RootState> = {};

export const STORE_KEY = "$_settings";

export const store = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
